import "./GrandstreamProducts.module.css";
import Header from "@/reusable_sections/Header";
import HeroProductosGrandstream from "./sections/HeroProductosGrandstream";
import GarantAsYBeneficios from "./sections/GarantAsYBeneficios";
import MediosDePago from "./sections/MediosDePago";
import Footer from "@/reusable_sections/Footer";
export default function GrandstreamProductsPage() {
  return <div>
      <Header />
      <HeroProductosGrandstream />
      <GarantAsYBeneficios />
      <MediosDePago />
      <Footer />
    </div>;
}